export default "__VITE_ASSET__DjABFx9u__"